import { useEffect } from 'react';
import { useQuery } from 'react-query';
import * as R from 'ramda';
import { useParams } from 'react-router';

import { useNotifications } from 'reapop';

import { withErrorBoundary } from '$app/modules/common/ErrorBoundary';
import CompanyDetailsPage from '../components/CompanyDetailsPage';
import ErrorPageContainer from '$app/modules/errorPage/containers/ErrorPage.container';

import '../styles/CompanyDetailPage.styles.scss';
import '../styles/Header.styles.scss';

const CompanyDetailsPageContainer = () => {
  const { notify } = useNotifications();

  const { companyName } = useParams();

  const { data, error, isFetching } = useQuery(
    `/content/careerfair-companies/${companyName}`,
  );

  useEffect(() => {
    if (error)
      notify({
        message: 'Could not load company. Please refresh the page.',
        status: 'error',
      });
  }, [error, notify]);

  return data?.statusCode === 500 ? (
    <ErrorPageContainer />
  ) : (
    <CompanyDetailsPage isFetching={isFetching} data={data?.body} />
  );
};

export default R.compose(withErrorBoundary)(CompanyDetailsPageContainer);
